import React from "react";

interface MoreButton2Props {
  onClick: () => void;
}

const MoreButton2: React.FC<MoreButton2Props> = ({ onClick }) => {
  return (
    <button onClick={onClick} className="btn btn-outline-secondary mb-4 w-100">
      더보기 &gt;
    </button>
  );
};

export default MoreButton2;
